const categories = [
  {
    name: 'Shoes', subtitle: 'Sneakers & Boots', count: 245,
    url: 'https://kaspreadsheet.com/category-911-Shoes.html',
    image: 'https://readdy.ai/api/search-image?query=Premium%20white%20leather%20sneakers%20with%20green%20accents%20on%20wooden%20floor%2C%20natural%20sunlight%20from%20window%2C%20minimalist%20lifestyle%20product%20photography%2C%20warm%20earthy%20tones&width=600&height=800&seq=cat-shoes-v4&orientation=portrait',
  },
  {
    name: 'Hoodies/Sweaters', subtitle: 'Streetwear Tops', count: 188,
    url: 'https://kaspreadsheet.com/category-912-Hoodies%2FSweaters.html',
    image: 'https://readdy.ai/api/search-image?query=Oversized%20charcoal%20grey%20hoodie%20hanging%20on%20minimal%20wooden%20hanger%20against%20warm%20terracotta%20wall%2C%20soft%20shadow%2C%20editorial%20streetwear%20photography&width=600&height=800&seq=cat-hoodies-v4&orientation=portrait',
  },
  {
    name: 'T-Shirts', subtitle: 'Basics & Graphics', count: 312,
    url: 'https://kaspreadsheet.com/category-913-T-Shirts.html',
    image: 'https://readdy.ai/api/search-image?query=Black%20cotton%20t-shirt%20neatly%20folded%20on%20light%20oak%20wooden%20surface%2C%20morning%20sunlight%20casting%20gentle%20shadows%2C%20minimalist%20product%20photography&width=600&height=800&seq=cat-tshirt-v4&orientation=portrait',
  },
  {
    name: 'Jackets', subtitle: 'Outerwear & Coats', count: 156,
    url: 'https://kaspreadsheet.com/category-914-Jackets.html',
    image: 'https://readdy.ai/api/search-image?query=Vintage%20brown%20leather%20bomber%20jacket%20on%20minimal%20wooden%20chair%2C%20warm%20afternoon%20light%2C%20editorial%20fashion%20photography%2C%20cozy%20atmospheric&width=600&height=800&seq=cat-jackets-v4&orientation=portrait',
  },
  {
    name: 'Pants/Shorts', subtitle: 'Bottoms & Denim', count: 203,
    url: 'https://kaspreadsheet.com/category-915-Pants%2FShorts.html',
    image: 'https://readdy.ai/api/search-image?query=Light%20wash%20denim%20jeans%20draped%20artistically%20on%20white%20linen%20fabric%2C%20soft%20natural%20side%20lighting%2C%20minimalist%20fashion%20editorial&width=600&height=800&seq=cat-pants-v4&orientation=portrait',
  },
  {
    name: 'Headwear', subtitle: 'Caps & Beanies', count: 98,
    url: 'https://kaspreadsheet.com/category-916-Headwear.html',
    image: 'https://readdy.ai/api/search-image?query=Navy%20blue%20baseball%20cap%20on%20rustic%20wooden%20table%20near%20window%2C%20morning%20light%2C%20warm%20tones%2C%20lifestyle%20product%20photography&width=600&height=800&seq=cat-headwear-v4&orientation=portrait',
  },
  {
    name: 'Sets', subtitle: 'Matching Outfits', count: 74,
    url: 'https://kaspreadsheet.com/category-917-Sets.html',
    image: 'https://readdy.ai/api/search-image?query=Coordinated%20olive%20green%20two-piece%20matching%20set%20displayed%20on%20minimal%20wooden%20rack%2C%20soft%20diffused%20lighting%2C%20modern%20fashion%20editorial&width=600&height=800&seq=cat-sets-v4&orientation=portrait',
  },
  {
    name: 'Underwear/Underpants', subtitle: 'Essentials', count: 67,
    url: 'https://kaspreadsheet.com/category-918-underwear%2Funderpants.html',
    image: 'https://readdy.ai/api/search-image?query=Soft%20cotton%20neutral%20tone%20underwear%20folded%20on%20white%20marble%20surface%2C%20gentle%20morning%20light%2C%20clean%20minimalist%20product%20photography&width=600&height=800&seq=cat-underwear-v4&orientation=portrait',
  },
  {
    name: 'Jersey', subtitle: 'Sports & Teams', count: 132,
    url: 'https://kaspreadsheet.com/category-919-Jersey.html',
    image: 'https://readdy.ai/api/search-image?query=Bright%20red%20soccer%20jersey%20with%20white%20stripes%20hanging%20on%20minimal%20rack%2C%20natural%20window%20light%2C%20sporty%20editorial%20photography&width=600&height=800&seq=cat-jersey-v4&orientation=portrait',
  },
  {
    name: 'Accessories', subtitle: 'Watches & Jewelry', count: 289,
    url: 'https://kaspreadsheet.com/category-920-Accessories.html',
    image: 'https://readdy.ai/api/search-image?query=Gold%20minimalist%20watch%20with%20brown%20leather%20strap%20on%20dark%20wood%20surface%2C%20warm%20candle%20light%20ambient%2C%20luxury%20product%20photography&width=600&height=800&seq=cat-accessories-v4&orientation=portrait',
  },
  {
    name: 'Bags', subtitle: 'Backpacks & Purses', count: 178,
    url: 'https://kaspreadsheet.com/category-921-Bags.html',
    image: 'https://readdy.ai/api/search-image?query=Vintage%20tan%20leather%20backpack%20on%20wooden%20bench%20in%20sunlight%2C%20outdoor%20cafe%20setting%2C%20warm%20afternoon%20light%2C%20lifestyle%20product%20photography&width=600&height=800&seq=cat-bags-v4&orientation=portrait',
  },
  {
    name: 'Belts', subtitle: 'Designer Belts', count: 95,
    url: 'https://kaspreadsheet.com/search-922/name/Bags.html',
    image: 'https://readdy.ai/api/search-image?query=Brown%20leather%20belt%20coiled%20elegantly%20on%20white%20linen%20with%20golden%20buckle%2C%20soft%20side%20lighting%2C%20minimalist%20luxury%20editorial%20photography&width=600&height=800&seq=cat-belts-v4&orientation=portrait',
  },
  {
    name: 'Perfumes', subtitle: 'Fragrances', count: 143,
    url: 'https://kaspreadsheet.com/search-923/name/Bags.html',
    image: 'https://readdy.ai/api/search-image?query=Amber%20glass%20perfume%20bottle%20on%20dark%20walnut%20surface%20with%20dried%20flowers%2C%20warm%20golden%20hour%20backlight%2C%20luxury%20fragrance%20product%20photography&width=600&height=800&seq=cat-perfumes-v4&orientation=portrait',
  },
  {
    name: 'OtherStuff', subtitle: 'Miscellaneous Finds', count: 210,
    url: 'https://kaspreadsheet.com/search-924/name/Bags.html',
    image: 'https://readdy.ai/api/search-image?query=Eclectic%20collection%20of%20sunglasses%20keychain%20wallet%20and%20notebook%20on%20light%20wood%20desk%2C%20warm%20overhead%20lighting%2C%20lifestyle%20flatlay%20photography&width=600&height=800&seq=cat-other-v4&orientation=portrait',
  },
];

export default function CategoryGrid() {
  return (
    <section className="py-16 md:py-24 px-4 md:px-8 bg-background-50">
      <div className="max-w-6xl mx-auto">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-4 mb-12">
          <div>
            <h2 className="text-3xl md:text-4xl font-bold text-foreground-950 font-heading mb-3">
              Shop by Category
            </h2>
            <p className="text-sm text-foreground-500">
              Browse shoes, hoodies, accessories and more
            </p>
          </div>
          <p className="text-xs text-foreground-400 font-label">
            14 categories available
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
          {categories.map((cat) => (
            <a
              key={cat.name}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group relative rounded-2xl overflow-hidden aspect-[3/4] bg-background-100 cursor-pointer"
            >
              <img
                src={cat.image}
                alt={`${cat.name} category`}
                title={`Sugargoo Spreadsheet ${cat.name} category`}
                className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/70 via-foreground-950/10 to-transparent"></div>

              <span className="absolute top-3 right-3 px-2.5 py-1 bg-background-50/90 backdrop-blur-sm rounded-full text-xs font-semibold text-foreground-800">
                {cat.count}
              </span>

              <div className="absolute bottom-0 left-0 right-0 p-4">
                <h3 className="text-sm md:text-base font-bold text-background-50 font-heading mb-0.5">
                  {cat.name}
                </h3>
                <p className="text-xs text-background-50/70">{cat.subtitle}</p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}